import type { LlmAdapter } from "../types.js";

export interface OpenAIAdapterOptions {
  apiKey?: string;
  model?: string;
}

export class OpenAIAdapter implements LlmAdapter {
  private apiKey: string;
  private model: string;

  constructor(options: OpenAIAdapterOptions = {}) {
    this.apiKey = options.apiKey ?? process.env.OPENAI_API_KEY ?? "";
    this.model = options.model ?? "gpt-4o";
    if (!this.apiKey) {
      throw new Error(
        "OPENAI_API_KEY environment variable is required for the openai adapter.",
      );
    }
  }

  async analyze(prompt: string): Promise<string> {
    const { default: OpenAI } = (await import("openai")) as {
      default: new (opts: { apiKey: string }) => OpenAIClient;
    };
    const client = new OpenAI({ apiKey: this.apiKey });
    const response = await client.chat.completions.create({
      model: this.model,
      messages: [{ role: "user", content: prompt }],
    });
    return response.choices?.[0]?.message?.content ?? "";
  }
}

interface OpenAIClient {
  chat: {
    completions: {
      create(opts: {
        model: string;
        messages: Array<{ role: string; content: string }>;
      }): Promise<{
        choices?: Array<{ message?: { content?: string } }>;
      }>;
    };
  };
}
